export default {
  loadMore: {
    en: 'Load more',
    sk: 'Načítať viac',
  },
};



// WEBPACK FOOTER //
// ./src/scripts/modules/Insights/Posts/messages.js